import React, { useEffect, useState } from 'react'

import Multiline from '../layouts/Multiline.jsx'

import { getEventTrends } from '_services/insights-v2.js'
import { formatAudienceComparison } from '../../charts/helpers/formatters.js'

import { logErrorAsync } from '_lib/utility.js'

const useGetAudienceComparisonData = (entities, timeRange) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  const entitiesHash = JSON.stringify(entities.map(({ _id }) => _id))
  const rangeHash = JSON.stringify(timeRange)
  useEffect(() => {
    setLoading(true)
    Promise.all(entities.map((entity) => getEventTrends({ audienceId: entity._id, timeRange })))
      .then((responses) => {
        const merge = entities.map((entity, index) => ({
          entity,
          data: responses[index],
        }))
        setData(merge)
      })
      .catch((error) => logErrorAsync(error))
      .finally(() => setLoading(false))
  }, [entitiesHash, rangeHash])

  return { data, loading }
}

const AudienceComparison = (props) => {
  const { data, index } = props
  const { time_frame, time_range, y_labels, title, description, selected_entities } = data

  const { data: newData, loading } = useGetAudienceComparisonData(selected_entities, time_range)

  const formatted = formatAudienceComparison({
    raw: newData,
    timeFrame: time_frame,
    type: y_labels,
  })

  return (
    <Multiline
      title={title}
      description={description}
      page={index + 1}
      timeFrame={time_frame}
      isLoading={loading}
      data={formatted}
      yLabel={y_labels}
    />
  )
}

export default AudienceComparison
